/* tslint:disable */

/**
 */
export class Langue {
    langId?: number;
    monetaryId?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/langue.ts